import { connect } from 'react-redux'
import { defineMessages } from 'react-intl'
import { avgSolarPanelInstallCost } from '../../../../../constants/equity'
import { HOMEOWNER_ENERGY_IMPROVEMENTS_TOPIC_KEY } from '../../../../../constants/topicKeys'
import Detail from './Detail'

export default {
  GemContainer: connect(state => ({
    qaTag: 'solarPanelsGem',
    amount: avgSolarPanelInstallCost,
  })),
  Detail,
  ...defineMessages({
    question: {
      id: 'Homeowner.equity.solarPanelsQuestion',
      defaultMessage: 'Can I finance solar panels with equity?',
    },
    topic: {
      id: 'Homeowner.equity.solarPanelsTopic',
      defaultMessage:
        'using equity for energy efficient home improvements like adding solar panels',
    },
  }),
  topicKey: HOMEOWNER_ENERGY_IMPROVEMENTS_TOPIC_KEY,
}
